<template>
  <div class="compressed-content">
    <h3 class="page-question">Are you on medication to raise your HDL cholesterol or manage triglycerides?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.triglycerides">
      <b-form-checkbox v-model="survey.bloodBiochemistry.triglycerides.isOnNoMedication" 
                       @change="onNoSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.triglycerides.isOnHDLCMedication"
                       @change="onMedicationSelected">
        HDL-C
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.triglycerides.isOnTriglyceridesMedication"
                       @change="onHDLCSelected">
        Triglycerides
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    data() {
      return {
        noMedication: null
      }
    },

    validations: {
      triglycerides: {
        anyOptionRequired: anyOptionRequired((value) => value.isOnNoMedication || value.isOnHDLCMedication
          || value.isOnTriglyceridesMedication)
      }
    },

    computed: {
      ...mapState(["survey"]),

      triglycerides() { return this.survey.bloodBiochemistry.triglycerides; }
    },

    methods: {
      onNoSelected(value) {
        this.setOptions(value, false, false);
      },

      onMedicationSelected(value) {
        this.setOptions(false, value, this.triglycerides.isOnTriglyceridesMedication);
      },

      onHDLCSelected(value) {
        this.setOptions(false, this.triglycerides.isOnHDLCMedication, value);
      },

      setOptions(noMedication, isOnHDLCMedication, isOnTriglyceridesMedication) {
        this.survey.bloodBiochemistry.triglycerides.isOnNoMedication = noMedication;
        this.survey.bloodBiochemistry.triglycerides.isOnHDLCMedication = isOnHDLCMedication;
        this.survey.bloodBiochemistry.triglycerides.isOnTriglyceridesMedication = isOnTriglyceridesMedication;
      }
    }
  };
</script>